import {
  Box,
  FatLoadingSpinner,
  Icon,
  TransparentButton,
} from '@redriverpress/system'
import useAudioPlayer from 'Common/hooks/useAudioPlayer'
import PropTypes from 'prop-types'
import { cloneElement, useState } from 'react'

import RecPlayButton from './RecPlayButton'

export default function Player({
  src,
  showCurrentTime,
  showRemainingTime,
  children,
  onDelete,
  small,
}) {
  const audioProps = useAudioPlayer()
  const {
    audioNode,
    canPlayThrough,
    currentTime,
    duration,
    isPlaying,
    remainingTime,
    togglePlay,
    setCurrentTime,
    setCanPlayThrough,
    setIsPlaying,
  } = audioProps

  const [isWaiting, setIsWaiting] = useState(false)

  const { minutes: remainingMinutes, seconds: remainingSeconds } = remainingTime

  const { minutes: currentMinutes, seconds: currentSeconds } = currentTime

  return (
    <>
      {/* Audio Blob */}
      <audio
        onCanPlayThrough={() => setCanPlayThrough(true)}
        onPlaying={() => setIsWaiting(false)}
        onTimeUpdate={() =>
          setCurrentTime(parseInt(audioNode.current.currentTime, 10))
        }
        onWaiting={() => setIsWaiting(true)}
        onEnded={() => setIsPlaying(false)}
        preload='auto'
        ref={audioNode}
        src={src}
      >
        <track kind='captions' />
      </audio>

      {children ? (
        cloneElement(children, audioProps)
      ) : (
        <Box display='flex' alignItems='center'>
          <RecPlayButton
            type='player'
            onClick={togglePlay}
            value={isPlaying ? currentTime.value : 0}
            maxValue={duration}
            small={small}
          >
            {canPlayThrough && !isWaiting ? (
              <Icon
                color='white'
                weight='light'
                icon={isPlaying ? 'pause' : 'play'}
                pl={isPlaying ? 0 : 1} // necessary cuz even tho the `play` icon is in the middle, it looks like it's slight to the left
              />
            ) : (
              <FatLoadingSpinner size='22px' color='gray400' />
            )}
          </RecPlayButton>
          {/* Current Time */}
          {showCurrentTime && (
            <Box fontSize='0.75rem' width='5ch'>
              {currentMinutes < 10 ? `0${currentMinutes}` : currentMinutes}:
              {currentSeconds < 10 ? `0${currentSeconds}` : currentSeconds}
            </Box>
          )}
          {showRemainingTime && (
            <Box fontSize='0.75rem' width='5ch' ml={2} fontWeight='600'>
              {remainingMinutes < 10
                ? `0${remainingMinutes}`
                : remainingMinutes}
              :
              {remainingSeconds < 10
                ? `0${remainingSeconds}`
                : remainingSeconds}
            </Box>
          )}
          {onDelete && (
            <TransparentButton onClick={onDelete}>
              <Icon icon='trash-alt' weight='light' />
            </TransparentButton>
          )}
        </Box>
      )}
    </>
  )
}

Player.defaultProps = {
  small: false,
  showCurrentTime: false,
  showRemainingTime: false,
  children: null,
}

Player.propTypes = {
  src: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
  children: PropTypes.node,
  showCurrentTime: PropTypes.bool,
  showRemainingTime: PropTypes.bool,
  small: PropTypes.bool,
}
